<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <data-view-sidebar ref="dataSidebar" :isSidebarActive="addNewDataSidebar" @saveChanges="saveChanges" @closeSidebar="toggleDataSidebar"
      :data="sidebarData" />
    <vs-popup id="deletePopup" class="holamundo" title="Boy Sil" :active.sync="deletePopupActive" v-esc="escapeDelete">
      <div class="w-full">
        <vs-row vs-type="flex" vs-w="12">
          <p>Bu Boy Silmek İstediğinize Eminmisiniz ? </p>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
          <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç
          </vs-button>
          <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
            @click="deleteData(deletedId)">
            Sil
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
    <vs-table ref="table" :data="sizes" v-model="selected">

      <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
        <vs-row id="panelHeaderRow" vs-type="flex" vs-w="12" vs-justify="space-between">
          <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col v-if="$isCenterBranch()" vs-type="flex" class="w-auto">
                <vx-tooltip text="Yeni Boy" position="top">
                  <vs-button @click="addNewData" class="panel-action text-success xlarge-button panel-action-box-shadow"
                    color="transparent" icon-pack="feather" icon="icon-plus">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>

      <template slot="thead">

        <vs-th class="w-10/12">
          <vs-button color="primary" type="flat">İsim
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12" v-if="$currentUser.branch.id==1">
          <vs-button icon-pack="feather" type="flat">İşlem
          </vs-button>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-10/12 text-center">
              <p class="font-medium text-center">{{ tr.name}}</p>
            </vs-td>
            <vs-td class="whitespace-no-wrap w-2/12" v-if="$currentUser.branch.id==1">
              <feather-icon icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                @click.stop="deletedId = tr.id;deletePopupActive = true;" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import DataViewSidebar from "./NewProductSize.vue";
  import {
    deleteProductSize,
    getProductSizeList
  } from "@/api/ProductSize.js";

  export default {
    components: {
      DataViewSidebar
    },
    data() {
      return {
        deletedId: null,
        deletePopupActive: false,
        selected: "",
        addNewDataSidebar: false,
        sidebarData: {},
        sizes: []
      };
    },
    methods: {
      saveChanges(val){
        this.toggleDataSidebar();
        if(!val) return;
        let index = this.sizes.findIndex(size => val.id == size.id);
        if(index < 0) this.sizes.push(val);
        else this.sizes[index] = _.clone(val);
      },
      escapeDelete() {
        if (this.deletePopupActive == true) {
          this.deletePopupActive = false;
          this.deletedId = null;
        }
      },
      addNewData() {
        this.sidebarData = {};
        this.toggleDataSidebar(true);
      },
      deleteData(id) {
        deleteProductSize(id).then(res => {
          if (res && res.status == 200) {
            let index = this.sizes.findIndex((p) => p.id == id)
            this.sizes.splice(index, 1);
            this.deletePopupActive = false;
            this.deletedId = null;
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Boy Silme Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Silme İşlemi Başarısız !"
            });
          }
        }).catch(x => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      },
      editData(data) {
        this.sidebarData = data;
        this.toggleDataSidebar(true);
      },
      toggleDataSidebar(val = false) {
        this.addNewDataSidebar = val;
        val == false ? this.selected = "" : null;
      },
      getProductSizeList: async function () {
        getProductSizeList().then(res => {
          if (res && res.status == 200) {
            this.sizes = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata :" + res.status,
              text: "Boy Listeleme Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      },
    },
    created() {
      this.getProductSizeList();
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 13) {
          if (this.deletePopupActive) this.deleteData(this.deletedId);
        }
      });
    },
    watch: {
      selected: function (val) {
        if (val != "" && this.$currentUser.branch.id == 1) this.editData(val);
      }
    }
  };

</script>

<style>
  .selectable:hover {
    cursor: pointer;
    box-shadow: 2px 2px 5px #000;
  }

  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute !important;
  }

</style>
